export default "__VITE_ASSET__DFMIqzuv__"